import Swal from 'sweetalert2';

class PopupAlert {


	constructor( element ) {
		this.element = element;
		if ( ! this.element ) {
			return;
		}
		this.id = element.getAttribute('data-id');
		this.message =  element.getAttribute('data-message');
		this.showMessage();
	}

	showMessage(){
		Swal.fire(this.message);
	}

}
document.addEventListener('DOMContentLoaded', function () {
	new PopupAlert( document.querySelector( '[data-component="popup-alert-course-blocked"]' ) );
}, false);


